import { parser } from 'app/lib/codemirror/grammars/snowsql';

const getNodeValue = (str, range) => str.substring(range.from, range.to);
const isFromExpression = (ref) => ref.name === 'FromExpression';
const isAliasClause = (ref) => ref.name === 'AliasClause';
const isTableObjectName = (ref) => ref.name === 'TableObjectName';
const isObjName = (ref) => ref.name === 'ObjName';
const isSelectStar = (ref) => ref.name === 'SelectTarget' && ref.node.lastChild.name === 'Star';
const isIdentifierExt = (ref) => ref.name === 'IdentifierExt';

function createAliasLookup(tree, sql) {
    const aliases = {};

    let isInsideFromExpression = false;
    let isInsideAliasClause = false;
    let tableName;
    let aliasName;

    function onEnterNode(ref) {
        if (isFromExpression(ref)) {
            isInsideFromExpression = true;
        }

        if (isAliasClause(ref)) {
            isInsideAliasClause = true;
        }

        if (isInsideFromExpression && isTableObjectName(ref)) {
            // Allow for namespaced tables by only looking at the last node
            if (isIdentifierExt(ref.node.lastChild)) {
                tableName = getNodeValue(sql, ref.node.lastChild);
            }

            // No need to further iterate over the children
            return false;
        }

        if (isInsideAliasClause && isIdentifierExt(ref)) {
            aliasName = getNodeValue(sql, ref);
        }
    }

    function onLeaveNode(ref) {
        if (isAliasClause(ref)) {
            isInsideAliasClause = false;
        }

        if (isFromExpression(ref)) {
            if (tableName && aliasName) {
                aliases[aliasName] = tableName;
            }

            isInsideFromExpression = false;
            tableName = undefined;
            aliasName = undefined;
        }
    }

    tree.iterate({
        enter: onEnterNode,
        leave: onLeaveNode
    });

    return aliases;
}

export function replaceSqlTableName(oldTableName, newTableName, sql) {
    const tree = parser.parse(sql);
    const aliases = createAliasLookup(tree, sql);
    const ranges = [];

    function pushRange(ref, checkAliases = false) {
        const identifier = getNodeValue(sql, ref);
        const isAlias = checkAliases && aliases.hasOwnProperty(identifier);

        if (!isAlias && identifier === oldTableName) {
            const { from, to } = ref;
            ranges.push({ from, to });
        }
    }

    function onEnterNode(ref) {
        if (isSelectStar(ref)) {
            const children = ref.node.getChildren('IdentifierExt');
            if (children.length) {
                const tableNode = children.at(-1);
                pushRange(tableNode, true);
            }
        } else if (isTableObjectName(ref)) {
            const children = ref.node.getChildren('IdentifierExt');
            const tableNode = children.at(-1);
            pushRange(tableNode, false);
        } else if (isObjName(ref)) {
            const children = ref.node.getChildren('IdentifierExt');
            const tableNode = children.length > 1 ? children.at(-2) : children.at(0);
            pushRange(tableNode, true);
            return false;
        }
    }

    tree.iterate({
        enter: onEnterNode
    });

    let result = sql;

    // Iterate backwards over the ranges so the earlier positions remain stable
    // while we update the string.
    let i = ranges.length;
    while (i > 0) {
        const { from, to } = ranges[--i];
        result = result.slice(0, from) + newTableName + result.slice(to);
    }

    return result;
}
